// 만원 단위 한글 표기 (표시용, 절삭)
const formatKoreanAmount = (num: number) => {
  const man = Math.floor(num / 10000);

  return `${man}만 원`;
};

//* 1인당 연간 기부 한도. 같은 페이지 FAQ가 안내하는 법정 상한과 같은 값이어야 한다.
export const ANNUAL_DONATION_LIMIT = 20_000_000;

export const clampToDonationLimit = (value: string) => {
  const parsedAmount = parseInt(value.replace(/,/g, ''), 10);

  if (isNaN(parsedAmount)) {
    return '';
  }

  return String(Math.min(parsedAmount, ANNUAL_DONATION_LIMIT));
};

// 세액공제 계산 (2026년 기준)
// - 0 ~ 10만 원: 100%
// - 10만 원 초과 ~ 20만 원: 44%
// - 20만 원 초과: 16.5%
export const calculateTaxDeduction = (amount: number) => {
  const details: { label: string; value: number }[] = [];

  if (amount <= 0) return { total: 0, details };

  // 10만원까지 100%
  if (amount <= 100000) {
    details.push({
      label: `${formatKoreanAmount(amount)} x 100%`,
      value: amount,
    });

    return { total: amount, details };
  }

  // 10만원 100%
  details.push({ label: '10만 원 x 100%', value: 100000 });
  let total = 100000;

  // 10만원 초과 ~ 20만원 이하: 44%
  if (amount <= 200000) {
    const excess = amount - 100000;
    const deduction = Math.floor(excess * 0.44);
    details.push({
      label: `${formatKoreanAmount(excess)} x 44%`,
      value: deduction,
    });
    total += deduction;

    return { total, details };
  }

  // 10만원 초과 ~ 20만원: 44%
  const midExcess = 100000;
  const midDeduction = Math.floor(midExcess * 0.44);
  details.push({ label: '10만 원 x 44%', value: midDeduction });
  total += midDeduction;

  // 20만원 초과: 16.5%
  const highExcess = amount - 200000;
  const highDeduction = Math.floor(highExcess * 0.165);
  details.push({
    label: `${formatKoreanAmount(highExcess)} x 16.5%`,
    value: highDeduction,
  });
  total += highDeduction;

  return { total, details };
};

// 답례품 혜택 계산 (기부금 10만원당 3만원)
export const calculateGiftBenefit = (amount: number) => {
  const units = Math.floor(amount / 100000);

  return units * 30000;
};
